import React, {Component} from 'react';
import {connect} from 'react-redux';
import LoadingBar from '../../common/LoadingBar';
import PopupError from '../../common/PopupErrorComponent/PopupError';
import UpdateFromPacer from '../../common/UpdateFromPacer';
import SearchReceipt from '../../search/results/searchReceipt/SearchReceipt';
import * as irSearchActions from '../../../redux/actions/irSearchActions';


class NoticeOfBankruptcyCaseFiling extends Component {

    componentDidMount() {
        if (this.props.purchase_right_away)
            this.purchaseNotice()
        else
            this.getNotice()
    }

    getNotice() {
        console.log('fetching notice from cache');
        this.props.dispatch(irSearchActions.getCaseData({ type: 'notice', case_uuid: this.props.case_uuid }))
    }

    purchaseNotice() {
        console.log('purchasing notice from pacer');
        this.props.dispatch(irSearchActions.purchaseCaseData({ type: 'notice', case_uuid: this.props.case_uuid }))
    }

    render() {
        if (!this.props.dataReady) return <LoadingBar/>;

        const {receipt} = this.props;
        return (
            <div>
                <PopupError errors={this.props.error} />
                <div className="ir-search-query" dangerouslySetInnerHTML={{__html: this.props.notice }}></div>
                { receipt ?
                    <SearchReceipt receipt={receipt}/> : null
                }

                <UpdateFromPacer
                    pacerUpdateHandler={ this.purchaseNotice.bind(this) }
                    pacerReceipt={receipt}
                    lastUpdated={this.props.lastUpdated}/>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const irSearch = state.get('irSearch');
    return {
        dataReady: irSearch.get('data_ready'),
        notice: irSearch.get('data'),
        receipt: irSearch.receipt,
        error: irSearch.get('error'),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NoticeOfBankruptcyCaseFiling)



// WEBPACK FOOTER //
// ./src/components/case/notice/NoticeOfBankruptcyCaseFiling.js